// Imports:

import 'jedlislider/src-webpack/jedlislider.js';
import jedliSlider from 'jedlislider/src-webpack/jedlislider.js';

window.addEventListener('load', () => {
    // Init trust sliders
    let slider = document.querySelectorAll("[data-slider='coop-slider']");
    if (slider.length > 0) {
        slider.forEach(element => {
            let slider = new jedliSlider(element, {
                "mode": "continuous",
                "slidesWidth": "auto",
                "visibleSlides": "auto",
                "speed": "5",
                "direction": "left",
                "pauseOnHover": "true",
                "responsive": [
                    {
                        "breakpoint": 992,
                        "options": {
                            "speed": "10"
                        }
                    }
                ]
            })
        });
    }

    let clientSlider = document.querySelectorAll("[data-slider='client-slider']");
    if (clientSlider.length > 0) {
        clientSlider.forEach(el => {
            let clientSlider = new jedliSlider(el, {
                "mode": "continuous",
                "slidesWidth": "auto",
                "visibleSlides": "auto",
                "speed": "5",
                "direction": "left",
                "pauseOnHover": "true",
                "responsive": [
                    {
                        "breakpoint": 992,
                        "options": {
                            "speed": "10"
                        }
                    }
                ]
            })
        });
    }
})